const ColdChainTransportation = () => {
  return (
    <div>
      <div className="flex flex-col justify-center items-center">
      <hr className="w-full lg:w-[50rem] md:w-[46rem]  mx-[auto] md:mx-[auto]"/>
        <div className="lg:flex md:flex sm:flex grid flex-1 justify-center items-start mx-auto lg:max-w-[50rem] md:max-w-[46rem] sm:max-w-[43rem] my-[5rem] gap-14">

          <div className="px-1 flex flex-col justify-center">
            <h1 className="font-bold lg:text-3xl text-2xl text-[#373737] lg:max-w-[25rem] md:w-[24rem] sm:w-[19rem]">
              Cold Chain Management
            </h1>
            <p className="text-sm text-md  lg:max-w-[25rem] md:w-[24rem] sm:w-[19rem] mt-[1rem]">
              Cold chain management requires the movement of chilled products at a temperature between 2° and 8°C, or at 
              even lower temperature ranges down to -70°C.
            </p> 
              <p className="text-sm text-md  lg:max-w-[25rem] md:w-[24rem] sm:w-[19rem] mt-[1rem]">
              TCS Fleet & Transport division provides complete solutions for controlled temperature-sensitive distribution 
              chain used in highly regulated industries such as food and beverage, pharmaceuticals and chemicals.
            </p>
            
          </div>
          <div className="flex-1 flex flex-col justify-center items-center sm:mt-[0rem] mt-[1rem]">
            <img src="/fleet-transportation/Cold-Chain-Transportation-Inside.jpg" alt="" className="rounded-md max-w-[100%]"/>
          </div>
        </ div>

      </div>

    </div>
  );
};
  
export default ColdChainTransportation;
  